// This is just a shim file to connect our custom typings to the jquery-ui npm package
require('jquery-ui/ui/widgets/sortable');


//////////////////
// WEBPACK FOOTER
// ./lib/jquery-ui-sortable.js
// module id = 625
// module chunks = 0